export const buildAssetUrl = (src: string | null | undefined, fallback: string): string => {
  if (!src || !src.trim()) return fallback;

  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
  const trimmed = src.trim();
  const absolute = trimmed.startsWith('http') ? trimmed : `${API_BASE_URL}${trimmed}`;

  if (import.meta.env.DEV && API_BASE_URL) {
    try {
      const apiHost = new URL(API_BASE_URL).host;
      const url = new URL(absolute);
      if (url.host === apiHost) {
        return url.pathname + url.search;
      }
    } catch {
      // On parse issues, fall back to absolute.
    }
  }

  return absolute;
};
